// Import model
import { CalendarEvent } from '../models/CalendarEvent';

// Import base class serializer
import { EntityOwnedModelSerializer } from './EntityOwnedModelSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CalendarEvent - handles JSON serialization and deserialization with type validation
 */
export class CalendarEventSerializer {
  /**
   * Deserializes a JSON string into a CalendarEvent instance
   */
  static deserialize(json: string): CalendarEvent {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CalendarEvent instance
   */
  static fromObject(obj: any): CalendarEvent {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CalendarEvent');
    }


    const instance: CalendarEvent = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      appointmentId: obj['appointmentId'] as string | undefined,
      appointmentIdName: obj['appointmentId|Name'] as string | undefined,
      externalId: obj['externalId'] as string | undefined,
      showAs: obj['showAs'] as string | undefined,
      type_: obj['type'] as string | undefined,
      sensitivity: obj['sensitivity'] as string | undefined,
      isCancelled: obj['isCancelled'] as boolean | undefined,
      isAllDay: obj['isAllDay'] as boolean | undefined,
      iCalUid: obj['iCalUid'] as string | undefined,
      startDate: obj['startDate'] as string | undefined,
      endDate: obj['endDate'] as string | undefined,
      externalUrl: obj['externalUrl'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CalendarEvent instances
   */
  static deserializeArray(json: string): CalendarEvent[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CalendarEvent instance to a JSON string
   */
  static serialize(instance: CalendarEvent): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CalendarEvent instance to a plain object
   */
  static toObject(instance: CalendarEvent): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'appointmentId': instance.appointmentId,
      'appointmentId|Name': instance.appointmentIdName,
      'externalId': instance.externalId,
      'showAs': instance.showAs,
      'type': instance.type_,
      'sensitivity': instance.sensitivity,
      'isCancelled': instance.isCancelled,
      'isAllDay': instance.isAllDay,
      'iCalUid': instance.iCalUid,
      'startDate': instance.startDate,
      'endDate': instance.endDate,
      'externalUrl': instance.externalUrl,
    };
  }

  /**
   * Serializes an array of CalendarEvent instances to a JSON string
   */
  static serializeArray(instances: CalendarEvent[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
